import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import ToastModal from "views/components/ToastModal";
const Hierarchy = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "code", label: "Structure Code" },
    { id: "officecode", label: "Office Code" },
    { id: "name", label: "Office Name" },
    { id: "parentcode", label: "Parent Code" },
    { id: "phone", label: "Office Phone Number" },
    { id: "email", label: "Email Address" },
    { id: "city", label: "City" },
    { id: "action", label: "Actions" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteHierarchyId, setDeleteHierarchyId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);

  // submit create function
  const handlecreatehierarchySubmit = () => {
    navigate(`/coreservice/hierarchy-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((hierarchy, index) => {
        let row = {
          code: hierarchy.masterTypeCode,
          officecode: hierarchy.masterTypeCode + " - " + hierarchy.code,
          name: hierarchy.name,
          parentcode: hierarchy.parentCode,
          phone: hierarchy.phoneNumber,
          email: hierarchy.email,
          city: hierarchy.city,
          action: getIcons(hierarchy.code),
          viewCode:hierarchy.code,
        };
        reportData.push(row);
      });

    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (hierarchy) => {
    return (
      <>
        <IconButton
          aria-label="Edit Hierarchy"
          onClick={(e) => {
            e.stopPropagation();
            onClickUpdateData(hierarchy)
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Hierarchy"
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(hierarchy)
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (hierarchy) => {
    navigate(`/coreservice/hierarchy-create/` + hierarchy);
  };

  // view function
  const onClickViewData = (code, type)=>{
    navigate(`/coreservice/hierarchy-createview/` + code );
  }
  // delete function
  const onClickDeleteData = (hierarchy) => {
    setConfirmationModalHeader("Hierarchy");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteHierarchyId(hierarchy);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteHierarchyId("");
  };
  const handlePositiveResponse = async () => {
    const hierarchyid = deleteHierarchyId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Hierarchy
    const res = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_DELETE + hierarchyid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete Hierarchy is successful", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      const officeCodeFormatted =
      `${row.masterTypeCode}-${row.code}`.toLowerCase();
      return (
        row.address.toLowerCase().includes(val.toLowerCase()) ||
        row.masterTypeCode.toLowerCase().includes(val.toLowerCase()) ||
        row.name.toLowerCase().includes(val.toLowerCase()) ||
        row.email.toLowerCase().includes(val.toLowerCase()) ||
        row.state.toLowerCase().includes(val.toLowerCase()) ||
        row.city.toLowerCase().includes(val.toLowerCase()) ||
        row.code.toLowerCase().includes(val.toLowerCase()) ||
        row.alternatePhoneNumber.toLowerCase().includes(val.toLowerCase()) ||
        row.masterTypeCode.toLowerCase().includes(val.toLowerCase()) ||
        row.pincode.toLowerCase().includes(val.toLowerCase()) ||
        row.phoneNumber.toLowerCase().includes(val.toLowerCase()) ||
        createDate.toLowerCase().includes(val.toLowerCase()) ||
        updatedDate.toLowerCase().includes(val.toLowerCase()) ||
         officeCodeFormatted.includes(val?.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Hierarchy"
          button1="Create Hierarchy"
          button1click={handlecreatehierarchySubmit}
          onSearchChange={onSearchChange}
          search
          searchLabel="Search For Hierarchy"
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={tableColumns}
            rows={selectedTableData}
            onClickViewData={onClickViewData}
            clickable
          />
        </TableContainer>
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

export default Hierarchy;
